import React from 'react'
import { useTranslation } from 'react-i18next'

import SelectInput from '../../../common/components/SelectInput/SelectInput'
import { FOCUS_ANCHORS } from '../../../common/constants/focusAnchors'
import { useFocusContext } from '../../../common/hooks/useFocus'
import { useNode } from '../../../common/hooks/useNode'
import { useModalEvents } from '../../../xstate/events'
import { useSelectedPractitioner, useSelectedSearchNodeId } from '../../../xstate/selectors'

const SearchServiceSelect: React.FC<React.PropsWithChildren<unknown>> = () => {
  const { t } = useTranslation()
  const { openServiceModal } = useModalEvents()
  const selectedSearchNodeId = useSelectedSearchNodeId()
  const selectedPractitioner = useSelectedPractitioner()
  const { node: selectedSearchNode } = useNode(selectedSearchNodeId)
  const { getRefForKey } = useFocusContext()

  return (
    <SelectInput
      label={t('component.serviceSearch.label')}
      value={selectedPractitioner?.name ?? selectedSearchNode?.name}
      onClick={openServiceModal}
      dataCy="searchSelect-textField"
      ref={getRefForKey(FOCUS_ANCHORS.SERVICE_SELECT)}
    />
  )
}

export default SearchServiceSelect
